import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@hooks/useAuth";
import { UserRole, Permission } from "@models/auth.types";
import { LoadingSpinner } from "@components/common";

interface ProtectedRouteProps {
  children: React.ReactNode;
  requiredRoles?: UserRole[];
  requiredPermissions?: Permission[];
  redirectTo?: string;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  children,
  requiredRoles,
  requiredPermissions,
  redirectTo = "/login",
}) => {
  const { isAuthenticated, loading, hasAnyRole, hasPermission } = useAuth();
  const location = useLocation();

  // Aguarda carregar informações de autenticação
  if (loading) {
    return <LoadingSpinner fullScreen message="Verificando autenticação..." />;
  }

  // Redireciona para login se não autenticado
  if (!isAuthenticated) {
    return <Navigate to={redirectTo} state={{ from: location }} replace />;
  }

  // Verifica roles necessárias
  if (requiredRoles && !hasAnyRole(requiredRoles)) {
    return <Navigate to="/acesso-negado" replace />;
  }

  // Verifica permissões necessárias
  if (requiredPermissions && !requiredPermissions.every(hasPermission)) {
    return <Navigate to="/acesso-negado" replace />;
  }

  return <>{children}</>;
};
